module.exports = __webpack_public_path__ + "i18n/ru_2f1044568313be27fed46cb5d3b78364.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ru.json
// module id = 2MCb
// module chunks = 153